<template>
  <div>
    <img :src="getImageFondo()" class="fondo" />
    <section id="inicio">
      <v-container fluid fill-height>
        <v-row style="z-index: 1">
          <v-col cols="12" md="6" class="pl-5 mt-5">
            <v-form>
              <v-row v-if="isSm">
                <v-col cols="12 pb-0">
                  <span
                    class="text-h4 font-weight-bold mb-2"
                    style="color: #00833e; display: block"
                    >{{ "MARKETING TOOLS" }}</span
                  >
                </v-col>
                <v-col cols="12 pb-0 pt-0">
                  <span class="text-body-1 font-weight-light"
                    >Todos los
                    <span class="text-body-1 font-weight-bold"
                      >materiales de comuncación</span
                    >
                    a tu alcance</span
                  >
                </v-col>
                <v-col cols="12 pb-0 pt-0">
                  <span class="text-body-2 font-weight-light"
                    >Entra y descárgate vídeos, posts e imágenes para comunicar
                    en tu óptica.</span
                  >
                </v-col>
              </v-row>
              <v-row v-else>
                <span
                  class="text-lg-h2 text-md-h3 font-weight-bold mb-2"
                  style="color: #00833e"
                  >MARKETING TOOLS</span
                >
                <span class="text-h5 text-md-h6 font-weight-light"
                  >Todos los
                  <span class="text-h5 text-md-h6 font-weight-bold"
                    >materiales de comuncación</span
                  >
                  a tu alcance</span
                >
                <span class="text-subtitle-1 font-weight-light"
                  >Entra y descárgate vídeos, posts e imágenes para comunicar en
                  tu óptica.</span
                >
              </v-row>
              <v-row class="pt-5 pr-5">
                <v-text-field
                  ref="txtUser"
                  v-model="code"
                  light="light"
                  prepend-icon="mdi-account"
                  label="Código Cliente"
                  :disabled="cargando"
                ></v-text-field>
              </v-row>
              <v-row class="pr-5">
                <v-text-field
                  v-model="password"
                  light="light"
                  label="Contraseña"
                  :type="show1 ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  :disabled="cargando"
                  :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="show1 = !show1"
                  @keypress.enter="downloadRetail()"
                ></v-text-field>
              </v-row>
            </v-form>
            <v-row class="d-flex justify-center pt-5 pb-3">
              <v-btn @click="downloadRetail()" :small="isMd" color="primary"
                >Acceder
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="12" md="6"
            ><img
              :src="getImage('moviles2.png')"
              class="imagenItem imagenMovil ml-3"
              :style="isMd ? 'transform: translateY(25%);' : ''"
            />
          </v-col>
        </v-row>
        <v-row style="z-index: 1" v-if="!isSm">
          <v-col cols="12" md="6">
            <img :src="getImage('promos2.png')" class="imagenItem" />
          </v-col>
          <v-col
            cols="12"
            md="6"
            :style="
              isMd
                ? 'transform: translate(10%,15%)'
                : 'transform: translate(20%,20%)'
            "
            ><img :src="getImage('retail.png')" class="imagenItem" />
          </v-col>
        </v-row>
        <v-row style="z-index: 1" v-else>
          <v-col cols="12" md="6">
            <img
              :src="getImage('retail.png')"
              class="imagenItem"
              style="transform: translate(10%, -40%)"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            :style="isMd ? 'transform: translate(20%,20%)' : ''"
          >
            <img :src="getImage('promos2.png')" class="imagenItem" />
          </v-col>
        </v-row>
        <indo-msgbox ref="indoMsgBox" />
      </v-container>
    </section>
  </div>
</template>

<script>
import "@/css/main.css";

export default {
  name: "HomeRetail",

  data: () => ({
    url: "",
    code: "",
    password: "",
    isSm: false,
    cargando: false,
    show1: false,
    errorTexto: "",
    isMd: false,
    isXs: false,
  }),
  watch: {
    isSm(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });

    // this.$http
    //   .get(process.env.VUE_APP_API_ENDPOINT + "Account/Ping", {
    //     timeout: 60000,
    //   })
    //   .then((res) => {
    //     console.log(res.data);
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });

    if (this.clientCode && this.marca && this.returnUrl) {
      this.downloadCatalogo();
    }
  },
  methods: {
    getImageFondo() {
      var images = require.context("@/assets/", false, /\.png$/);
      return images("./fondo.png");
    },
    getImage(nameImage) {
      var images = require.context("@/assets/", false, /\.png$/);
      return images("./" + nameImage);
    },
    onResize() {
      this.isSm = window.innerWidth < 960;
      this.isMd = window.innerWidth < 1264 && window.innerWidth > 960;
      this.isXs = window.innerWidth < 600;
    },
    downloadRetail() {
      if (this.returnUrl === "" || !this.returnUrl) {
        this.$refs.indoMsgBox.confirm({
          showDlg: true,
          message: "No se ha introducido la url del catálogo de destino",
          btnOKColor: "red",
          showNoBtn: false,
        });
        this.cargando = false;
      } else {
        var url = this.returnUrl;
        this.cargando = true;
        var dto = {
          SapUser: this.userFormateado,
          SapPassword: this.password,
          ReturnUrl: url,
          IPAddress: this.ipAddres,
          Marca: this.marca,
        };
        this.$http
          .post(process.env.VUE_APP_API_ENDPOINT + "Account/GetIfLogged", dto, {
            timeout: 60000,
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.isSuccess) {
              this.goToInicio();
              var href = `https://cloudsrv.indo.es/index.php/s/${url}`;
              window.open(href, "_blank");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    downloadCatalogo() {
      if (this.returnUrl === "" || !this.returnUrl) {
        this.$refs.indoMsgBox.confirm({
          showDlg: true,
          message: "No se ha introducido la url del catálogo de destino",
          btnOKColor: "red",
          showNoBtn: false,
        });
      } else {
        var url = this.returnUrl;
        this.cargando = true;
        var dto = {
          SapUser: this.userFormateado,
          SapPassword: this.password,
          ReturnUrl: url,
          IPAddress: this.ipAddres,
          Marca: this.marca,
        };
        this.$http
          .post(
            process.env.VUE_APP_API_ENDPOINT + "Account/MantenerSesion",
            dto,
            {
              timeout: 60000,
            }
          )
          .then((res) => {
            console.log(res.data);
            if (res.data.isSuccess) {
              this.goToInicio();
              var href = `https://${this.ipAddres}`;
              window.open(href, "_blank");
            } else {
              // alert(res.data.message);
              console.log(res.data.message);
            }
          })
          .catch((err) => {
            console.error(err);
            this.cargando = false;
          });
      }
    },
    goToInicio() {
      this.$store.state.logueado = true;
      this.$store.state.usuario = this.code;
      this.$vuetify.goTo("#inicio");
    },
  },
  computed: {
    logueado() {
      return this.$store.state.logueado;
    },
    userFormateado() {
      return this.code && this.code.padStart(10, "0");
    },
    returnUrl() {
      return this.$route.query.returnUrl;
    },
    clientCode() {
      return this.$route.query.cliente;
    },
    marca() {
      return this.$route.query.marca;
    },
    ipAddres() {
      if (this.$route.fullPath.split("&").length >= 3) {
        var ipStr = this.$route.fullPath
          .split("&")[0]
          .replace("?", "")
          .replace("/", "");
        return `${ipStr.substring(0, 3).trimStart("0")}.${ipStr
          .substring(3, 3)
          .trimStart("0")}.${ipStr.substring(5, 3).trimStart("0")}.${ipStr
          .substring(9, 3)
          .trimStart("0")} `;
      }
      return "";
    },
  },
};
</script>
